/**
 * @flow
 */

import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { differenceInCalendarDays, isBefore } from 'date-fns';
import { Calendar } from '../containers';

const intlMessages = defineMessages({
    placeholder: {
        id: 'report.DateRange.placeholder',
        defaultMessage: 'Date range',
    },
});

class DateRange extends Component {
    state: {
        from: ?Object,
        to: ?Object,
        enteredTo: ?Object,
    };

    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }

    getInitialState() {
        const { fromDate, toDate } = this.props;
        return {
            from: fromDate,
            to: toDate,
            enteredTo: null,
        };
    }

    isSelectingFirstDay = (from, to, day) => {
        const isBeforeFirstDay = from && isBefore(day, from);
        const isRangeSelected = from && to;
        return !from || isBeforeFirstDay || isRangeSelected;
    };

    onDayClick = (day, closePopup) => {
        const {
            onChange,
            disabledAfter,
            disabledBefore,
            limitDays,
        } = this.props;
        const { from, to } = this.state;

        if (disabledAfter && day > disabledAfter) {
            return;
        }

        if (disabledBefore && day < disabledBefore) {
            return;
        }

        if (this.isSelectingFirstDay(from, to, day)) {
            // First click chooses a new start — don't apply the span limit
            // (which is relative to the previous, now-stale `from`).
            this.setState({
                from: day,
                to: null,
                enteredTo: null,
            });
        } else {
            // Second click chooses the end — cap the from→to span here.
            const numberOfDays = differenceInCalendarDays(
                new Date(day),
                new Date(from),
            );
            if (limitDays && numberOfDays > limitDays - 1) {
                return;
            }

            this.setState({
                to: day,
                enteredTo: day,
            });

            if (onChange) {
                onChange(from, day);
            }

            if (closePopup) {
                closePopup();
            }
        }
    };

    onDayMouseEnter = day => {
        const { from, to } = this.state;
        if (!this.isSelectingFirstDay(from, to, day)) {
            this.setState({
                enteredTo: day,
            });
        }
    };

    handleResetClick = () => {
        this.setState(this.getInitialState());
    };

    render() {
        const {
            intl,
            workingDays,
            customFormat,
            disabledAfter,
            customSize,
            allowAllDates,
        } = this.props;
        const { from, to, enteredTo } = this.state;
        const modifiers = { workday: workingDays };

        return (
            <Calendar
                value={from && to ? [from, to] : undefined}
                placeholder={intl.formatMessage(intlMessages.placeholder)}
                iconPosition="left"
                customSize={customSize}
                format={customFormat || 'MMM d'}
                dayPickerProps={{
                    numberOfMonths: 2,
                    // Open on the month of the current selection so a range in
                    // a previous month is visible without paging back.
                    defaultMonth: from || undefined,
                    modifiers,
                    disabled: disabledAfter ? { after: disabledAfter } : undefined,
                    selected: { from: from || undefined, to: enteredTo || to || undefined },
                    onDayMouseEnter: this.onDayMouseEnter,
                    onDayClick: this.onDayClick,
                    mode: 'range',
                }}
            />
        );
    }
}

export default injectIntl(DateRange);
